import Carusell,{slides,Gallery,texto_slides} from '../components/Componen_index'

const Inicio = function Inicio() {
    return (
        <main>            
            <Carusell slides={slides} />
            <Gallery/>
        </main>
    )
}

export default Inicio